'use strict';

// Per-document-type configuration for the reusable [[DocumentThroughput-Provider.js]] dashboard. Each entry declares the
// DocumentType to scope to and the breakdown dimensions the agency cares about for that type. Adding a new document type
// to the throughput dashboard is a config entry here — no code change.
//
// Dimension shape: { Key, Label, ItemLabel, logField|docField, resolve }
//   • logField  — group by a field on the DocumentApprovalLog transition (e.g. CreatingIDUser = who submitted/approved).
//   • docField  — group by a field on the (lite) Document (e.g. IDProject).
//   • resolve   — 'user' | 'project' to turn the id into a display name (batched). Omit for a literal key.
//
// NOTE on DocumentType: it is a ReportNamedInstance identifier. 'Inspection-Dossier' is stored as a literal string here
// (verified against the Meadow filter), but other report types may be a hash — put the exact value the Document rows carry.

const CONFIGS =
{
	'Inspection-Dossier':
	{
		DocumentType: 'Inspection-Dossier',
		Title: 'Inspection submissions & approvals',
		Subtitle: 'Dossier submission and approval throughput across the inspection program — the inspection\'s real status is driven by this approval workflow.',
		Icon: 'fas fa-clipboard-check',
		Dimensions:
		[
			{ Key: 'submitter', Label: 'By submitter', ItemLabel: 'User', logField: 'CreatingIDUser', resolve: 'user' },
			{ Key: 'project', Label: 'By structure (project)', ItemLabel: 'Project', docField: 'IDProject', resolve: 'project' },
		],
	},

	// ---- Future: Structural Concrete reports, broken down by Producer and Project (the agency's ask). ----
	// Wire when the concrete report type + its Producer source are confirmed. Producer likely isn't on the lite Document,
	// so its dimension will need a `docField` once the producer id is exposed there (or a small resolver extension).
	// '<StructuralConcreteReportType>':
	// {
	//     DocumentType: '<literal-or-hash>',
	//     Title: 'Structural concrete reports',
	//     Subtitle: 'Concrete report submission and approval throughput.',
	//     Icon: 'fas fa-cubes',
	//     Dimensions:
	//     [
	//         { Key: 'producer', Label: 'By producer', ItemLabel: 'Producer', docField: 'IDProducer', resolve: 'organization' },
	//         { Key: 'project', Label: 'By project', ItemLabel: 'Project', docField: 'IDProject', resolve: 'project' },
	//     ],
	// },
};

// A generic config for any document type not explicitly registered (submitter + project breakdowns).
function genericConfig(pType)
{
	return {
		DocumentType: pType,
		Title: `${pType} throughput`,
		Subtitle: 'Submission and approval throughput driven by the document approval workflow.',
		Icon: 'fas fa-file-signature',
		Dimensions:
		[
			{ Key: 'submitter', Label: 'By submitter', ItemLabel: 'User', logField: 'CreatingIDUser', resolve: 'user' },
			{ Key: 'project', Label: 'By project', ItemLabel: 'Project', docField: 'IDProject', resolve: 'project' },
		],
	};
}

function resolveConfig(pType)
{
	if (!pType) { return CONFIGS['Inspection-Dossier']; }
	return CONFIGS[pType] || genericConfig(pType);
}

module.exports = { CONFIGS, resolveConfig };
